import React from 'react';
import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import PrintButton from '../Buttons/PrintButton';
import DateIntervalPicker from '../Forms/DateIntervalPicker';
import Table from './AggregateTable';
import useStyles from './styles';

const View = ({
  data,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  isBusy,
  onPrint
}) => {
  const classes = useStyles();

  return <Grid container>
    <Grid item xs={12}>
      <Header
        {...{startDate, setStartDate, endDate, setEndDate}}
      />
    </Grid>
    {isBusy
      ? <Grid container xs={12} justify='center'>
        <CircularProgress className={classes.spinner}/>
      </Grid>
      : isEmpty(data)
      ? <Grid container xs={12} justify='center'>
        <Typography variant='h6' className={classes.title}>
          Nenhum item encontrado...
        </Typography>
      </Grid>
      : <>
        <Grid item>
          <PrintButton onClick={onPrint}/>
        </Grid>
        <Grid item xs={12} className={classes.tableContainer}>
          <AnalyticsTable
            data={data.analysis}
          />
        </Grid>
        <Grid item xs={12} className={classes.tableContainer}>
          <CountTable
            data={data.count}
          />
        </Grid>
      </>
    }
  </Grid>;
};

export const AnalyticsTable = ({
  data,
}) => {
  const columns = [
    { width: 150 , flexGrow: 1 , label: 'Valor Total (R$)'     , dataKey: 'value'           , numeric: true } ,
    { width: 150 , flexGrow: 1 , label: 'Valor Médio (R$)'     , dataKey: 'meanValue'       , numeric: true } ,
    { width: 130 , flexGrow: 1 , label: 'Distâcia Total (Km)'  , dataKey: 'distance'        , numeric: true } ,
    { width: 130 , flexGrow: 1 , label: 'Distância Média (Km)' , dataKey: 'meanDistance'    , numeric: true } ,
    { width: 130 , flexGrow: 1 , label: 'Espera Média (h)'   , dataKey: 'meanWaiting'     , numeric: true } ,
    { width: 130 , flexGrow: 1 , label: 'Viagem Média (h)'   , dataKey: 'meanTravel'      , numeric: true } ,
    { width: 130 , flexGrow: 1 , label: 'Ocupação Média (h)' , dataKey: 'meanUnavailable' , numeric: true } ,
    { width: 100 , flexGrow: 1 , label: 'N Viagens'            , dataKey: 'deliveryCount'   , numeric: true } ,
    { width: 130 , flexGrow: 1 , label: 'N Final'              , dataKey: 'finalCount'      , numeric: true } ,
    { width: 100 , flexGrow: 1 , label: 'N Ocupado'            , dataKey: 'unavailable'     , numeric: true } ,
    { width: 100 , flexGrow: 1 , label: 'N Pausado'            , dataKey: 'paused'          , numeric: true } ,
  ];

  return <Table
    id='analyticsTable'
    {...{data, columns}}
  />;
};

export const CountTable = ({
  data,
}) => {
  const columns = [
    { width: 150 , flexGrow: 1 , label: 'N Delegado'       , dataKey: 'choose'         , numeric: true } ,
    { width: 150 , flexGrow: 1 , label: 'N V Ocupados'     , dataKey: 'unavailable'    , numeric: true } ,
    { width: 150 , flexGrow: 1 , label: 'N V Pausados'     , dataKey: 'paused'         , numeric: true } ,
    { width: 100 , flexGrow: 1 , label: 'N Transferências' , dataKey: 'transfer'       , numeric: true } ,
    { width: 150 , flexGrow: 1 , label: 'N V Modificados'  , dataKey: 'updateMeta'     , numeric: true } ,
    { width: 150 , flexGrow: 1 , label: 'N V Removidos'    , dataKey: 'deleteMeta'     , numeric: true } ,
    { width: 150 , flexGrow: 1 , label: 'N PC Atualizadas' , dataKey: 'updateDelivery' , numeric: true } ,
    { width: 150 , flexGrow: 1 , label: 'N PC Removidas'   , dataKey: 'deleteDelivery' , numeric: true } ,
  ];

  return <Table
    id='countTable'
    {...{data, columns}}
  />;
};

export const Header = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate
}) => {
  const classes = useStyles();

  return <Grid
    container
    justify='center'
    alignItems='center'
    className={classes.header}
  >
    <Grid item xs={12}>
      <DateIntervalPicker
        {...{startDate, setStartDate, endDate, setEndDate}}
      />
    </Grid>
  </Grid>;
};

export default View;
